import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=1b62725e"
import script from "./StaffView.vue?vue&type=script&lang=js"
export * from "./StaffView.vue?vue&type=script&lang=js"
import style0 from "./StaffView.vue?vue&type=style&index=0&id=1b62725e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QIcon,QSpinner,QTooltip});
